<form [formGroup]="detectionPointForm" (ngSubmit)="onSubmit()" class="create-detection-point-form">
    @if (isProcessing) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <!-- Basic Information -->
    <div class="form-section">
        <h3 class="section-title">Basic Information</h3>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Detection Point Name</mat-label>
                <input matInput formControlName="name" placeholder="e.g., Parking Entry Point 1">
                <mat-icon matSuffix>location_on</mat-icon>
                @if (detectionPointForm.get('name')?.hasError('required')) {
                <mat-error>
                    Detection point name is required
                </mat-error>
                }
                @if (detectionPointForm.get('name')?.hasError('minlength')) {
                <mat-error>
                    Name must be at least 2 characters
                </mat-error>
                }
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Linked Camera</mat-label>
                <mat-select formControlName="cameraId">
                    <mat-option value="">-- Select a camera --</mat-option>
                    @for ( camera of cameras; track camera.id) {
                    <mat-option [value]="camera.id">
                        <mat-icon>videocam</mat-icon>
                        {{ camera.deviceName }}
                    </mat-option>
                    }
                </mat-select>
                <mat-icon matSuffix>videocam</mat-icon>
                @if (detectionPointForm.get('cameraId')?.hasError('required')) {
                <mat-error>
                    Please select a camera
                </mat-error>
                }
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Description (Optional)</mat-label>
                <textarea matInput formControlName="description" rows="3"
                    placeholder="e.g., Detects vehicles entering from the north side"></textarea>
                <mat-icon matSuffix>description</mat-icon>
            </mat-form-field>
        </div>
        <!-- PointDirection Selector -->
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Expected Directions</mat-label>
                <mat-select formControlName="expectedDirections">
                    @for ( direction of directions; track direction) {
                    <mat-option [value]="direction">
                        <mat-icon>{{ getDirectionIcon(direction) }}</mat-icon>
                        {{ getDirectionEmoji(direction) }} {{ direction }}
                    </mat-option>
                    }
                </mat-select>
                <mat-icon matSuffix>directions</mat-icon>
                @if (detectionPointForm.get('expectedDirections')?.hasError('required')) {
                <mat-error>
                    Please select at least one expected direction
                </mat-error>
                }
            </mat-form-field>
        </div>
    </div>

    @if (canBeReversible) {
    <!-- Reversible lane -->
    <div class="form-section">
        <h3 class="section-title">Reversible Lane</h3>

        <div class="form-row">
            <mat-checkbox formControlName="isReversible" class="checkbox-item">
                <span class="checkbox-label">Switch direction by time</span>
            </mat-checkbox>
        </div>

        @if (isReversible) {
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Entry from</mat-label>
                <input matInput type="time" formControlName="laneEntryFrom">
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Exit from</mat-label>
                <input matInput type="time" formControlName="laneExitFrom">
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Handover (minutes)</mat-label>
                <input matInput type="number" min="2" formControlName="laneHandoverMinutes">
                @if (detectionPointForm.get('laneHandoverMinutes')?.hasError('min')) {
                <mat-error>
                    At least 2 minutes
                </mat-error>
                }
            </mat-form-field>
        </div>
        }
    </div>
    }

    <!-- Status Configuration -->
    <div class="form-section">
        <h3 class="section-title">Status</h3>

        <div class="form-row">
            <mat-checkbox formControlName="isActive" class="checkbox-item">
                <span class="checkbox-label">Activate this detection point</span>
            </mat-checkbox>
        </div>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
        <button mat-stroked-button (click)="onCancel()" type="button" [disabled]="isProcessing">
            <mat-icon>close</mat-icon>
            Cancel
        </button>
        <button mat-raised-button color="primary" type="submit" [disabled]="isProcessing || !detectionPointForm.valid">
            <mat-icon>{{ isProcessing ? 'hourglass_empty' : 'check' }}</mat-icon>
            {{ isProcessing ? 'Creating...' : 'Create Detection Point' }}
        </button>
    </div>
</form>